<template>
	<div class="controlDom" >
		<div class="title-top">
			<div style="display: flex;">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.PanRemoteControl }}</div>
			</div>
			<img style="float: right;width: 1.5vw;cursor: pointer;z-index: 9;" src="../../../../static/imgV2/closeIcon.png" alt="" @click="ifCameraClear()">
		</div>
		<div style="width: 92%;background: #122279;border-radius: 8px;margin: 0.5vw auto;padding: 1px 0 1vw 0;">
			<div class="control-title" style="width: 43%;">{{ languageJson.cameraAction }}</div>
			<div style="display: flex;justify-content: space-between;">
				<div style="width: 50%;display: flex;align-items: center;justify-content: center;flex-direction: column;">
					<img style="width: 3.56vw;margin-bottom: -1.33vw;cursor: pointer;" :src="pTZImg_t" @mousedown="mouseFun('top', true)" @mouseup="mouseFun('top', false)" alt="">
					<div style="margin-left: -0.05vw;">
						<img style="width: 2vw;cursor: pointer;" :src="pTZImg_l" @mousedown="mouseFun('left', true)" @mouseup="mouseFun('left', false)" alt="">
						<img style="width: 2vw;margin-left: 0.66vw;cursor: pointer;" :src="pTZImg_r" @mousedown="mouseFun('right', true)" @mouseup="mouseFun('right', false)" alt="">
					</div>
					<img style="width: 3.56vw;margin-top: -1.65vw;cursor: pointer;" :src="pTZImg_b" @mousedown="mouseFun('bottom', true)" @mouseup="mouseFun('bottom', false)" alt="">
					<div class="iconImg">
						<img style="width: 0.7vw;margin-left: 1vw;" src="../../../../static/imgV2/icon-top.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsUp }}</span>
					</div>
					<div class="iconImg">
						<img style="width: 0.7vw;margin-left: 1vw;" src="../../../../static/imgV2/icon-left.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsDown }}</span>
					</div>
					<div class="iconImg">
						<img style="width: 0.7vw;margin-left: 1vw;" src="../../../../static/imgV2/icon-bottom.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsLeft }}</span>
					</div>
					<div class="iconImg">
						<img style="width: 0.7vw;margin-left: 1vw;" src="../../../../static/imgV2/icon-right.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsRight }}</span>
					</div>
				</div>
				<div style="width: 50%;display: flex;align-items: center;justify-content: space-between;flex-direction: column;">
					<img style="width: 3vw;" src="../../../../static/imgV2/mouse.png" alt="">
					<div class="iconImg">
						<span>{{ languageJson.mouseWheel }}</span>
						<img style="width: 0.7vw;" src="../../../../static/imgV2/mouse-top.png" alt="">
						<span>{{ languageJson.PanMagnification }}</span>
					</div>
					<div class="iconImg">
						<span>{{ languageJson.mouseWheel }}</span>
						<img style="width: 0.7vw;" src="../../../../static/imgV2/mouse-bottom.png" alt="">
						<span>{{ languageJson.PanZoomingin }}</span>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
			<div class="btn1 btnDo" @click='reset()'>{{ languageJson.PanTiltReset }}</div>
		</div>
	</div>
</template>

<script>
	import {
		angleControl
	} from '@/api/admin.js'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		name: '',
		data() {
			return {
			  timer:null,
				languageJson: languageJson,
				pTZImg_t: require('../../../../static/imgV2/top.png'),
				pTZImg_l: require('../../../../static/imgV2/left.png'),
				pTZImg_r: require('../../../../static/imgV2/right.png'),
				pTZImg_b: require('../../../../static/imgV2/bottom.png'),
				pTZImg_top: require('../../../../static/imgV2/top.png'),
				pTZImg_left: require('../../../../static/imgV2/left.png'),
				pTZImg_right: require('../../../../static/imgV2/right.png'),
				pTZImg_bottom: require('../../../../static/imgV2/bottom.png'),
				pTZImg_top_check: require('../../../../static/imgV2/top-check.png'),
				pTZImg_left_check: require('../../../../static/imgV2/left-check.png'),
				pTZImg_right_check: require('../../../../static/imgV2/right-check.png'),
				pTZImg_bottom_check: require('../../../../static/imgV2/bottom-check.png'),
				ifPTZBottom: false,
				ifPTZRight: false,
				ifPTZLeft: false,
				ifPTZTop: false,
				constTop: null,
				constLeft: null,
			}
		},
		props: {
			robotInfo: null,
			timeEnd: Boolean,
			ifCamera: Boolean
		},
		mounted() {
			this.elementListen(this)
			// 以叠加式监听绑定，不覆盖其他组件的 document.onmouseup
			document.addEventListener('mouseup', this.handleGlobalMouseUp)
		},
		beforeDestroy() {
			// 仅移除自身绑定的监听，不影响其他组件的全局事件
			document.removeEventListener('mouseup', this.handleGlobalMouseUp)
		},
		methods: {
			// 全局兜底：在任意位置松开鼠标都复位方向状态，避免 mouseup 落在按钮外导致停止指令漏发
			handleGlobalMouseUp() {
				if (this.ifPTZTop) this.ifPTZTop = false
				if (this.ifPTZLeft) this.ifPTZLeft = false
				if (this.ifPTZRight) this.ifPTZRight = false
				if (this.ifPTZBottom) this.ifPTZBottom = false
			},
			mouseFun(value, status) {
				if (value == 'top') {
					this.ifPTZTop = status
				} else if (value == 'left') {
					this.ifPTZLeft = status
				} else if (value == 'right') {
					this.ifPTZRight = status
				} else if (value == 'bottom') {
					this.ifPTZBottom = status
				}
			},
			elementListen(that) {
				document.onkeydown = function(e) {
					if (that.ifCamera) {
						if (e.keyCode == 37) {
							that.ifPTZLeft = true
						} else if (e.keyCode == 38) {
							that.ifPTZTop = true
						} else if (e.keyCode == 39) {
							that.ifPTZRight = true
						} else if (e.keyCode == 40) {
							that.ifPTZBottom = true
						}
					}
				}
				document.onkeyup = function(e) {
					if (that.ifCamera) {
						if (e.keyCode == 37) {
							that.ifPTZLeft = false
						} else if (e.keyCode == 38) {
							that.ifPTZTop = false
						} else if (e.keyCode == 39) {
							that.ifPTZRight = false
						} else if (e.keyCode == 40) {
							that.ifPTZBottom = false
						}
					}
				}
			},
			ifCameraClear() {
				this.$emit('clear', true)
			},
			reset() {
				let that = this
				let ajaxPost = {
					number: that.robotInfo.number,
					tenantInfoId: getItem('tenantInfoId'),
					direction: '-1'
				}
				angleControl(ajaxPost).then(() => {
					// that.sliderValue = 2
					that.$emit('sliderValue', true)
				})
			},
			posTangle(type, value) {
				let that = this
				let direction = '0'
				that.constTop = that.constTop ? that.constTop : '0'
				that.constLeft = that.constLeft ? that.constLeft : '0'
				// 上下左右 1，4，2，3
				if (value) {
					if (type == '1') {
						if (that.constTop == '0') {
							that.constTop = '1'
						} else {
							return false;
						}
					} else if (type == '2') {
						if (that.constLeft == '0') {
							that.constLeft = '1'
						} else {
							return false;
						}
					} else if (type == '3') {
						if (that.constLeft == '0') {
							that.constLeft = '2'
						} else {
							return false;
						}
					} else if (type == '4') {
						if (that.constTop == '0') {
							that.constTop = '2'
						} else {
							return false;
						}
					}
				} else {
					if (type == '1' || type == '4') {
						if (that.constTop == '0') {
							return false
						} else {
							that.constTop = '0'
						}
					} else if (type == '2' || type == '3') {
						if (that.constLeft == '0') {
							return false
						} else {
							that.constLeft = '0'
						}
					}
				}

				if (that.constTop == '1') {
					if (that.constLeft == '1') {
						direction = '5'
					} else if (that.constLeft == '2') {
						direction = '6'
					} else {
						direction = '1'
					}
				} else if (that.constTop == '2') {
					if (that.constLeft == '1') {
						direction = '8'
					} else if (that.constLeft == '2') {
						direction = '7'
					} else {
						direction = '2'
					}
				} else if (that.constTop == '0') {
					if (that.constLeft == '1') {
						direction = '3'
					} else if (that.constLeft == '2') {
						direction = '4'
					} else {
						direction = '0'
					}
				}
				let ajaxPost = {
				  number: that.robotInfo.number,
				  tenantInfoId: getItem('tenantInfoId'),
				  direction
				}
				// 按下发一次方向指令，松开发一次停止指令（direction=0），不使用定时器
				angleControl(ajaxPost).then(() => {})
			}
		},
		watch: {
			ifPTZTop: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_t = val ? this.pTZImg_top_check : this.pTZImg_top
					this.posTangle('1', val)
				}
			},
			ifPTZLeft: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_l = val ? this.pTZImg_left_check : this.pTZImg_left
					this.posTangle('2', val)
				}
			},
			ifPTZRight: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_r = val ? this.pTZImg_right_check : this.pTZImg_right
					this.posTangle('3', val)
				}
			},
			ifPTZBottom: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_b = val ? this.pTZImg_bottom_check : this.pTZImg_bottom
					this.posTangle('4', val)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../index/detail.less";
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/cameraFlv.vue